    import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Pagination from "../../ResuableCompoment/Pagination";
import SearchBar from "../../ResuableCompoment/SearchBar";
import useApi from "../../CustomHooks/useApi";
import { useSelector } from "react-redux";

const OnboardingComplete = () => {
  const [loading, setLoading] = useState(true);
  const [formsData, setFormsData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("confirm");
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [merchantLoading, setMerchantLoading] = useState(false);
  const itemsPerPage = 10;

  const userId = useSelector((state) => state.auth.employeeDetails.userId);
  const rolesuperonboarding = useSelector(
    (state) => state.auth.employeeDetails.role
  );

  const { callApi: pendingOnboard } = useApi(`/staff/onboard/get/full`, "GET");
  const { callApi: editmerchant } = useApi(`/staff/onboard/edit/user`, "POST");

  useEffect(() => {
    fetchFormsData();
  }, []);

  const fetchFormsData = async () => {
    try {
      const response = await pendingOnboard(null, `?userId=${userId}`);
      setFormsData(response || []);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  const handleEditClick = (userID) => {
    setSelectedUserId(userID);
    setPopupType("confirm");
    setPopupMessage("Are you sure you want to edit this merchant?");
    setShowPopup(true);
  };

  const handlePopupConfirm = async () => {
    setMerchantLoading(true);
    await editmerchant(null, `?userId=${selectedUserId}`);
    setMerchantLoading(false);
    setPopupType("success");
    setPopupMessage("Merchant moved to edit section successfully.");
  };

  const filteredForms = formsData.filter(
    (form) =>
      form.meta.fullName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      form.role.toLowerCase().includes(searchQuery.toLowerCase()) ||
      form.mobileNumber.includes(searchQuery)
  );

  return (
    <div className="min-h-screen bg-[#EEF1F5] p-6">
      {/* Search */}
      <div className="mb-6">
        <SearchBar
          placeholder="Search by Name, Role or Mobile"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="bg-white rounded-xl border border-gray-200 shadow-sm p-6"
      >
        {/* Heading */}
        <div className="mb-5 text-center">
          <h2 className="text-lg font-semibold text-[#0A2A4F]">
            Completed Onboarding
          </h2>
        </div>

        {/* Table */}
        {loading ? (
          <p className="text-center text-gray-500">Loading...</p>
        ) : filteredForms.length === 0 ? (
          <p className="text-center text-red-500">No data found</p>
        ) : (
          <Pagination
            items={filteredForms}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={setCurrentPage}
            renderItems={(currentItems) => (
              <div className="overflow-x-auto">
                <table className="min-w-full border border-gray-200 rounded-lg overflow-hidden">
                  <thead className="bg-[#0A2A4F] text-white">
                    <tr>
                      {[
                        "Name",
                        "Mobile",
                        "PAN",
                        "Role",
                        "User ID",
                        "Status",
                        rolesuperonboarding === "SUPER_ONBOARDING" && "Action",
                      ]
                        .filter(Boolean)
                        .map((h, i) => (
                          <th
                            key={i}
                            className="px-4 py-3 text-left text-sm font-medium"
                          >
                            {h}
                          </th>
                        ))}
                    </tr>
                  </thead>

                  <tbody>
                    {currentItems.map((form, index) => (
                      <tr
                        key={index}
                        className="border-b last:border-none hover:bg-gray-50 transition"
                      >
                        <td className="px-4 py-3">
                          {form.meta.fullName}
                        </td>
                        <td className="px-4 py-3">
                          {form.mobileNumber}
                        </td>
                        <td className="px-4 py-3">
                          {form.panCard}
                        </td>
                        <td className="px-4 py-3">
                          <span className="px-2 py-1 rounded-full bg-slate-100 text-slate-700 text-xs">
                            {form.role}
                          </span>
                        </td>
                        <td className="px-4 py-3">
                          {form.userId}
                        </td>
                        <td className="px-4 py-3 text-sm">
                          {form.meta.Document_status}
                        </td>

                        {rolesuperonboarding === "SUPER_ONBOARDING" && (
                          <td className="px-4 py-3">
                            <button
                              onClick={() => handleEditClick(form.userId)}
                              className="px-4 py-1.5 rounded-lg text-sm bg-[#0A2A4F] text-white hover:bg-[#08305e]"
                            >
                              Edit
                            </button>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          />
        )}
      </motion.div>

      {/* Popup */}
      {showPopup && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-6 w-[380px] shadow-xl">
            <h3 className="text-lg font-semibold text-center mb-3">
              {popupType === "confirm" ? "Confirm" : "Success"}
            </h3>

            <p className="text-sm text-gray-600 text-center mb-6">
              {popupMessage}
            </p>

            <div className="flex justify-center gap-4">
              {popupType === "confirm" ? (
                <>
                  <button
                    onClick={() => setShowPopup(false)}
                    className="px-5 py-2 rounded-lg border"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handlePopupConfirm}
                    disabled={merchantLoading}
                    className="px-5 py-2 rounded-lg bg-[#0A2A4F] text-white"
                  >
                    {merchantLoading ? "Processing..." : "Confirm"}
                  </button>
                </>
              ) : (
                <button
                  onClick={() => setShowPopup(false)}
                  className="px-6 py-2 rounded-lg bg-[#0A2A4F] text-white"
                >
                  OK
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OnboardingComplete;
